export default __webpack_public_path__ + "static/media/steem-rice.514daef2.jpg";